import { z } from "zod";
import { timestampSchema } from "./timestamp";

/**
 * Reguły slug rodziny: a-z, 0-9, myślnik. 3-20 znaków, lowercase.
 * Slug jest globalnie unikalny — używany w „login dziecka" jako
 * identyfikator rodziny (zamiast podawania emaila / hid).
 */
export const householdSlugSchema = z
  .string()
  .min(3)
  .max(20)
  .regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]$/, "Tylko a-z, 0-9 i myślnik");

export const householdSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(60),
  /**
   * Pseudonim rodziny — globalnie unikalny. Dziecko loguje się przez
   * username + slug + hasło. Opcjonalny dla istniejących household
   * sprzed v1.6.0; nowe muszą mieć (rodzic ustawia w Settings).
   */
  slug: householdSlugSchema.optional(),
  currency: z.literal("PLN"),
  createdAt: timestampSchema,
  createdBy: z.string(),
  /**
   * Marker grandfathered access dla HH założonych przed startem płatności
   * Stripe. Ustawiane raz przy create (sentinel 2099-01-01 = "praktycznie
   * wiecznie"), niezmienne przez klienta (rules zabraniają update).
   *
   * Migracja: gdy podłączasz Stripe, skrypt iteruje HH z `earlyAccessUntil`
   * i tworzy im `subscription = { status: "grandfathered", validUntil:
   * earlyAccessUntil, ... }`. HH bez markera idą normalną drogą paywall.
   */
  earlyAccessUntil: timestampSchema.optional(),
  /** Kiedy HH dostał early access (createdAt-like, ale żeby było jasne). */
  earlyAccessAt: timestampSchema.optional(),
});
export type Household = z.infer<typeof householdSchema>;
